module.exports = __webpack_public_path__ + "static/img/08.a0bab68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/02/08.jpg
// module id = oTJx
// module chunks = 0